<template>
    <v-flex xs12 sm12 d-block class="card-dados convidado card-dados__mobile">
        <h3 class="card-dados__titulo">Notificar Fornecedores por E-mail</h3>

        <az-call-to-action flat css-class="d-flex align-center btn-adicionar" v-if="exibirBotaoAdicionar"
                           @click="exibirCampoDeNovoEmail">
            <v-icon class="icone" color="white">
                add
            </v-icon>
            Novo E-mail
        </az-call-to-action>

        <div class="area-novo" v-show="!exibirBotaoAdicionar">
            <label>Novo E-mail:</label>
            <v-text-field name="E-mail" placeholder="Informe o e-mail" class="area-novo__input"
                          :error-messages="errors.collect('E-mail')" maxlength="150" autofocus
                          v-model="emailConvidado" v-validate="'required|email'" ref="emailConvidado"></v-text-field>
            <v-tooltip top>
                <v-btn id="botaoAdicionar" slot="activator" outline flat small color="primary"
                       @click="adicionarEmail">
                    <v-icon size="20">check</v-icon>
                </v-btn>
                Adicionar
            </v-tooltip>
            <v-tooltip top>
                <v-btn id="botaoCancelar" slot="activator" outline flat small color="#777"
                       @click="cancelarEmail">
                    <v-icon size="20">close</v-icon>
                </v-btn>
                Cancelar
            </v-tooltip>
        </div>

        <v-data-table :headers="colunas" :items="value"
                      no-data-text="Não há linhas de e-mails adicionados"
                      class="az-table-list tabela-email">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.email }}
                </td>
                <td class="table-actions">
                    <botao-excluir @excluir="exibirDialogoExclusaoEmail(props.item.id)"/>
                </td>
            </template>
        </v-data-table>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoExclusao"
                              @confirmado="tratarEventoExcluirEmailConvidado"
                              @recusado="mostrarDialogoExclusao = false"/>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelConvidadoEdicao',
    props: {
        value: {
            required: true
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            emailConvidado: undefined,
            colunas: [
                {
                    text: 'E-mail',
                    value: 'email',
                    sortable: true,
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    class: 'primary--text'
                }
            ],
            emailId: null,
            mostrarDialogoExclusao: false,
            exibirBotaoAdicionar: true
        }
    },
    methods: {
        exibirCampoDeNovoEmail() {
            this.exibirBotaoAdicionar = false
            setTimeout(() => {
                this.focusInput()
            },300)
        },
        async adicionarEmail() {
            await this.validarCampoObrigatorio()
            this.$emit('adicionarEmailConvidado', this.emailConvidado)
            this.cancelarEmail()
        },
        cancelarEmail() {
            this.exibirBotaoAdicionar = true
            this.emailConvidado = null
            this.$validator.reset()
        },
        exibirDialogoExclusaoEmail(id) {
            this.emailId = id
            this.mostrarDialogoExclusao = true
        },
        tratarEventoExcluirEmailConvidado() {
            this.mostrarDialogoExclusao = false
            this.$emit('excluirEmailConvidado', this.emailId)
        },
        async validarCampoObrigatorio() {
            const estaValido = await this.$validator.validate('E-mail')
            if (!estaValido) {
                throw new Error('Campo obrigatório.')
            }
        },
        focusInput() {
            this.$refs.emailConvidado.focus()
        }
    }
}
</script>

<style scoped lang="stylus">
    .convidado div[role="listitem"]
        display none

    .tabela-email
        padding 10px 16px 16px

    .btn-adicionar
        border 0
        color #777 !important
        padding 0
        margin 0 0 0 16px

        &:hover:before, &:focus:before, &:active:before
            background-color #fff

        .icone
            background-color var(--v-primary-base)
            padding 6px
            border-radius 20px
            margin-right 8px

    @media (max-width 720px)
        .convidado .btn-adicionar
            margin-bottom 10px

        .tabela-email
            padding 0

            td:nth-of-type(1):before
                content "E-mail:"

            td:nth-of-type(2):before
                display none
</style>
